// const apiendpoint = "http://localhost:5001";
// const apiendpoint = "https://allapi.shram.io";
const apiendpoint = "https://test-backend.shram.io";

export { apiendpoint };
